<template>
  <div class="notifications-wrapper">
    <template v-for="(item,index) in notifications">
      <NotificationCard :item="item" :key="index"/>
    </template>
  </div>
</template>

<script>
import NotificationCard from "./components/NotificationCard"
export default {
components:{
    NotificationCard
},
methods:{
  async fetchNotifications(){
    const notifications=await this.$store.dispatch("Menu/fetchNotifications")
    return notifications
  },
},
computed:{
  notifications(){
    return this.$store.state.Menu.notifications
  }
},
mounted(){
  this.fetchNotifications()
}
}
</script>

<style>

</style>